import React from 'react';
const links = ['Términos y condiciones', 'Política de privacidad', 'Política de reembolso', 'Contacto'];
export function Footer() {
  return <footer className="w-full bg-ink px-5 pb-16 pt-16" data-id="element-98" data-mp="3ggu1qsai619z">
      <div className="mx-auto max-w-5xl text-center" data-id="element-99" data-mp="32oe11y52qfc8">
        <p className="font-display text-3xl leading-none text-white" data-id="element-100" data-mp="32lrkxa44arie">
          Kit Educación Física Lista<span className="text-brand" data-id="element-101" data-mp="36nd4tff2k623">™</span>
        </p>
        <p className="mt-4 font-display text-lg tracking-[0.06em] text-volt" data-id="element-102" data-mp="3ues7xaeo6ree">
          Planificá menos. Enseñá mejor.
        </p>
        <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-white/50" data-id="element-103" data-mp="37xyao5wgelp">
          Material de Educación Física listo para usar, de 1º grado de Primaria
          a 6º año de Secundaria.
        </p>
        <nav aria-label="Pie de página" data-id="element-104" data-mp="3qfjj8jyhljpp">
          <ul className="mt-9 flex flex-wrap items-center justify-center gap-x-7 gap-y-3 text-sm font-semibold text-white/60" data-id="element-105" data-mp="29ynlrlrph7ej">
            {links.map(link => <li key={link} data-id="element-106" data-mp="2ezl35w4w5xez">
                <a href="#offer" className="transition-colors duration-150 ease-out hover:text-volt" data-id="element-107" data-mp="3l9k6jf1oprec">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mx-auto mt-10 max-w-2xl border-t border-white/10 pt-8 text-xs leading-relaxed text-white/40" data-id="element-108" data-mp="3gctnciul2fop">
          © 2026 Kit Educación Física Lista™. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}